import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import UseProtocolTemplatePage from './UseProtocolTemplatePage.js';

export default WithGASetup(UseProtocolTemplatePage, AuthContext);
